export const scrollTable = {
    methods: {
        scrollbar(e) {
            return e[0] ? e[0].scrollWidth > e.innerWidth() : false;
        },
        left(e) {
            const conent = this.$el.querySelector(e);
            conent.scrollLeft -= 150;
            event.preventDefault();
        },
        right(e) {
            const conent = this.$el.querySelector(e);
            conent.scrollLeft += 150;
            event.preventDefault();
        },
    }
}